/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "F:/zhaoyanning/\u627F\u5FB7\u5E02\u653F\u5E9C-\u5BF9\u63A5\u94F6\u884C/mobile-master/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.match.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import XButton from 'vux/src/components/x-button';
import { Dialog, Toast } from 'vant';
export default {
  components: {
    XButton: XButton
  },
  data: function data() {
    return {
      chooseName: [],
      //餐厅名字
      chooseList: [],
      //餐厅列表
      windowObj: '',
      //餐厅编号
      isShow: false,
      //是否显示订餐记录
      indexColor: 0,
      remark: '',
      alertFlag: false,
      userSerial: '',
      //人员序列
      dsGolist: false,
      //是否可以调整
      img: '',
      orderMeal: 0,
      //订餐方式
      startDate: '',
      endDate: '',
      ymAppId: '',
      //正元app对接唯一编号
      code: '' //正元app对接返回的code标识用于换取人员信息

    };
  },
  methods: {
    getSysDate: function getSysDate() {
      var _this = this;

      this.$utils.Tools.loadShow();
      this.$api.Sys.getSystemDate(this.$params.mode).then(function (response) {
        _this.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this.$code.success) {
          _this.$utils.Tools.toastShow(msg);

          _this.finished = true;
        } else {
          _this.startDate = _this.$utils.DateUtils.getMonthStart(data.sysDate.substring(0, 7));
          _this.endDate = _this.$utils.DateUtils.getMonthEnd(data.sysDate.substring(0, 7));
        }
      }).catch(function () {
        _this.$utils.Tools.httpError();
      });
    },
    alrtBtn: function alrtBtn() {
      if (this.windowObj == '' && this.windowObj.length == 0) return this.$utils.Tools.toastShow('未选择餐厅！');
      if (this.dsGolist == true) return this.$utils.Tools.toastShow('没有订餐权限哦！');
      this.$router.push({
        path: '/MealOrdering',
        query: {
          placeId: this.windowObj,
          cancelFlag: '1',
          placeName: this.placeName
        }
      });
    },
    getId: function getId(item, i) {
      this.windowObj = item.depSerial;
      this.placeName = item.depName;
      this.indexColor = i;
      this.$utils.Store.setLocalItem('payType', 3);

      if (this.chooseList.length == 1) {
        if (!this.dsGolist) {
          this.$router.replace({
            path: '/MealOrdering',
            query: {
              placeId: this.chooseList[0].depSerial,
              cancelFlag: '1'
            }
          });
        } else {
          this.$router.go(-1);
        }
      }
    },
    goR: function goR() {
      this.$router.push({
        path: '/OrderRecord'
      });
    },
    //点击共享订单
    goShare: function goShare() {
      var _this2 = this;

      //获取共享订单列表
      this.$api.Meal.getShareList({
        pageIndex: this.curPage,
        pageSize: this.pageNum,
        search: {
          startDate: this.startDate,
          mealState: ['6'],
          endDate: this.endDate
        }
      }).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this2.$code.success) {
          _this2.$utils.Tools.toastShow(msg);

          _this2.finished = true;
        } else {
          //若存在共享单（共享订单数量大于0）
          if (data.records && data.records.length > 0) {
            // 跳转共享订单列表页面
            _this2.$router.push({
              path: '/OrderShare'
            });
          } else {
            //暂无共享订单，提示共享订单
            Toast('糟糕，还没有人共享订单，请稍后再来哦');
          }
        }
      }).catch(function () {
        _this2.$utils.Tools.httpError();
      });
    },
    userPermission: function userPermission() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.$api.Meal.otderByUserSsion(_this3.userSerial).then(function (res) {
                  if (res.data.orderFlag == 0) {
                    _this3.dsGolist = true;

                    _this3.$utils.Tools.toastShow('没有订餐权限哦~');
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    selectListByChoose: function selectListByChoose(params) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  depSerial: params
                };
                _context2.next = 3;
                return _this4.$api.AcDep.selectListByChoose(params).then(function (res) {
                  // 获取全部数据
                  // 全部数据获取成功后存进自己里
                  _this4.chooseList = res.data;
                  _this4.windowObj = _this4.chooseList[0].depSerial;
                  _this4.placeName = _this4.chooseList[0].depName;
                  _this4.orderMeal = _this4.chooseList[0].spareCol2;

                  _this4.$utils.Store.setLocalItem('payType', 2); //定义一个数组用于存储订餐方式的显示隐藏状态


                  //定义一个数组用于存储订餐方式的显示隐藏状态
                  _this4.chooseList.forEach(function (item, i) {
                    _this4.chooseName.push({
                      key: res.data[i].depSerial,
                      value: res.data[i].depName,
                      type: res.data[i].payType,
                      spareCol2: res.data[i].spareCol2
                    });

                    if (item.payType != 0) {
                      _this4.$utils.Store.setLocalItem('payType', 3);
                    }
                  });

                  for (var i = 0; i < _this4.chooseList.length; i++) {
                    _this4.chooseList[i].restaurant = 'false';
                    _this4.chooseList[i].Delivery = 'false';
                    _this4.chooseList[i].pack = 'false';
                    var DiningStyle = _this4.chooseList[i].spareCol9;

                    for (var j = 0; j < DiningStyle.length; j++) {
                      if (DiningStyle[j] == 0) {
                        //支持堂食
                        _this4.chooseList[i].restaurant = 'true';
                      } //支持配送


                      //支持配送
                      if (DiningStyle[j] == 1) {
                        _this4.chooseList[i].Delivery = 'true';
                      } //支持外带


                      //支持外带
                      if (DiningStyle[j] == 2) {
                        _this4.chooseList[i].pack = 'true';
                      }
                    }
                  } //若只有一个餐厅可选择，直接跳转该餐厅订餐页面


                  //若只有一个餐厅可选择，直接跳转该餐厅订餐页面
                  if (_this4.chooseList.length == 1 && _this4.orderMeal != 1) {
                    if (!_this4.dsGolist) {
                      _this4.$router.replace({
                        path: '/MealOrdering',
                        query: {
                          placeId: _this4.chooseList[0].depSerial,
                          cancelFlag: '1',
                          placeName: _this4.chooseList[0].depName
                        }
                      });
                    } else {
                      _this4.$router.go(-1);
                    }
                  } else if (_this4.chooseList.length == 1 && _this4.orderMeal == 1) {
                    _this4.$utils.Tools.toastShow('报餐暂未开发');
                  }
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    /**
     * @function获取订餐说明弹窗
     *      wzx
     *   2020.0403
     **/
    showExplain: function showExplain(id) {
      var _this5 = this;

      this.$utils.Tools.loadShow();
      this.$api.Meal.getExplain(id).then(function (response) {
        _this5.$utils.Tools.loadHide();

        var code = response.code,
            data = response.data;

        if (+code === _this5.$code.success) {
          if (data != null) {
            _this5.remark = data;
            _this5.img = data.spareCol2;
            var img = "<img style='width:100%'  src=".concat(data.spareCol2, ">");
            var Dsrc;

            if (data.spareCol2) {
              Dsrc = data.dineShow + '\n \n \n' + img;
            } else {
              Dsrc = data.dineShow + '\n \n \n';
            }

            Dialog.alert({
              title: '订餐说明',
              message: Dsrc,
              messageAlign: 'left'
            }).then(function () {// on close
            });
          } else {
            Toast('暂无相关说明');
          }
        }
      }).catch(function () {
        _this5.$utils.Tools.httpError();
      });
    },
    getUserInfo: function getUserInfo() {
      var _this6 = this;

      this.$utils.Tools.loadShow();
      this.$api.Meal.getUserInfo(this.code).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(response) {
          var code, msg, data;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this6.$utils.Tools.loadHide();

                  code = response.code, msg = response.msg, data = response.data;

                  if (!(+code !== _this6.$code.success)) {
                    _context3.next = 6;
                    break;
                  }

                  _this6.$utils.Tools.toastShow(msg);

                  _context3.next = 15;
                  break;

                case 6:
                  _this6.$utils.Store.setItem('token', data.token);

                  _this6.$utils.Store.setItem('userSerial', data.userSerial);

                  _this6.userSerial = _this6.$utils.Store.getItem('userSerial');

                  _this6.getSysDate();

                  _this6.userSerial = _this6.$utils.Store.getItem('userSerial');
                  _context3.next = 13;
                  return _this6.userPermission();

                case 13:
                  _context3.next = 15;
                  return _this6.selectListByChoose(10000);

                case 15:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function () {
        _this6.$utils.Tools.httpError();
      });
    }
  },
  created: function created() {
    var _this7 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var ua, _url, errCode, token;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // 判断当前环境
              ua = window.navigator.userAgent.toLowerCase(); // 非微信环境

              if (!(ua.match(/MicroMessenger/i) != 'micromessenger')) {
                _context4.next = 19;
                break;
              }

              _url = window.location.href;
              errCode = _url.match(/errCode=(\S*)&v/)[1];

              if (!(errCode == 0)) {
                _context4.next = 17;
                break;
              }

              _this7.code = _url.match(/code=(\S*)&errCode/)[1]; //获取登录后的token

              token = window.vm.$utils.Store.getItem('token'); // 若token存在，则无需再次登录获取人员信息

              if (!token) {
                _context4.next = 16;
                break;
              }

              _this7.getSysDate();

              _this7.userSerial = _this7.$utils.Store.getItem('userSerial');
              _context4.next = 12;
              return _this7.userPermission();

            case 12:
              _context4.next = 14;
              return _this7.selectListByChoose(10000);

            case 14:
              _context4.next = 17;
              break;

            case 16:
              //获取app人员信息
              _this7.getUserInfo();

            case 17:
              _context4.next = 25;
              break;

            case 19:
              // 微信环境
              _this7.getSysDate();

              _this7.userSerial = _this7.$utils.Store.getItem('userSerial');
              _context4.next = 23;
              return _this7.userPermission();

            case 23:
              _context4.next = 25;
              return _this7.selectListByChoose(10000);

            case 25:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },
  mounted: function mounted() {}
};